import { useState } from "react";
import { FaTimes, FaCheck } from "react-icons/fa";
import Edit from "../../assets/images/edit.svg"; 
import { createPortal } from "react-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreateNFCAlbum from '../../apis/createNFCAlbum/createNFCAlbum';
const EdiAlbumBanner = ({ rowData, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
const [isLoading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

 const handleSave = async (e) => {
    if ( selectedFile) {
      setLoading(true);

      const formData = new FormData();
      formData.append('Title', rowData.title);
      formData.append('Description', rowData.description);
      formData.append('SpecialMessage', rowData.specialMessage);
      formData.append('isPublicLibrary', rowData.isPublicLibrary);
      if (selectedFile) formData.append('AlbumCover', selectedFile);

      if (rowData.eventUrl) {
        formData.append('EventUrl', rowData.eventUrl);
      }
      else {
        formData.append('EventUrl', 'album');
      }
      if (rowData.id) {
        formData.append('AlbumId', rowData.id);
        formData.append('FolderName', rowData.albumPic)
        if (selectedFile) {
          formData.append('IsPicChanged', true);
          formData.append('AlbumCover', selectedFile);
          
        } else {
          formData.append('IsPicChanged', false);
          
        }
      }
      else{
        formData.append('FolderName', '')
      }
      console.log("FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      try {
        const authenticationToken = sessionStorage.getItem('token');
        const response = await CreateNFCAlbum(authenticationToken, formData);
        if (response.result === 1 && response.errorValue === null) {

          if (rowData.title) {
            toast.success('Banner successfully updated!');
            setTimeout(() => {
              closePopup();

            }, 1000);
          }

        } else if (response.result === 0 && response.errorValue && response.errorValue.errorCode === 103) {
          console.error('Invalid authentication token:', response.errorValue.errorText);
          sessionStorage.clear();

        } else {
          console.error('API call returned an error:', response);
        }
      } catch (error) {
        console.error('API call error:', error);
      } finally {
        setLoading(false);
      }
    }
    closePopup();
  };

  const closePopup = () => {
    setIsEditing(false);
    setPreview(null);
    setSelectedFile(null);
  };

  return (
    <div className="banner-cell">
      <div className="banner-wrapper">
        <img
          src={rowData.albumPic}
          alt={rowData.title}
          className="banner-image"
          style={{
    width: "180px",
    height: "120px",
    objectFit: "contain",
    backgroundColor: "#f0f0f0" 
  }}
        />
        <img
          src={Edit}
          alt="Edit"
          className="edit-icon"
          onClick={() => setIsEditing(true)}
        />
      </div>

      {isEditing &&
        createPortal(
          <div className="popup-overlay">
            <div className="popup">
              <h3 className="modal-title">Edit Banner</h3>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="file-input"
              />
              {preview && (
                <div className="preview">
                  <img src={preview} alt="Preview" />
                </div>
              )}
              <div className="actions">
                <FaCheck className="icon save" onClick={handleSave} size={22} />
                <FaTimes className="icon cancel" onClick={closePopup} size={22} />
              </div>
            </div>
          </div>,
          document.body // ✅ ensures popup renders outside the table
        )}
    </div>
    
  );
  <ToastContainer />
};

export default EdiAlbumBanner;
